

















































































































































import { Component, Prop, Vue } from "vue-property-decorator";

import * as def from "@/definitions";

import { Document } from "@/model/document2/document";
import { Layer } from "@/model/document2/page/surface/design/layer/layer";

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import AlignControl from "../alignControl/alignControl.vue";

@Component({
  components: {
    ValueEdit,
    ArrowDown,
    ArrowRight,
    AlignControl
  }
})
export default class LinePosition extends Vue {
    @Prop()
    private layer!: Layer;
    
    // 裏面を持つか?
    private get hasReverse()
    {
        var document = this.$store.getters.document;
        return document.hasReverseSurface;
    }

  //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
  //こいつはpropsでもらいたい → storeから直接取ってくることになった
  openStatus = {
    opend: true
  };

  linePositionContentsOpenAnimate = false;
  linePositionContentsCloseAnimate = false;

  open() {
    if (this.openStatus.opend) {
      this.linePositionContentsCloseAnimate = true;
      setTimeout(() => {
        this.openStatus.opend = false;
        this.linePositionContentsOpenAnimate = false;
        this.linePositionContentsCloseAnimate = false;
      }, 200);
    } else {
      this.openStatus.opend = true;
      this.linePositionContentsOpenAnimate = true;
      setTimeout(() => {
        this.linePositionContentsOpenAnimate = false;
      }, 250);
    }
  }
  //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    public changeLayerProperty(value: any, propertyName: string, isFinish) {
        if (propertyName == "name") {
        // レイヤー名変更
        this.$emit("doCommand", "changeLayerProperty", {
            layer: this.layer,
            propertyName: propertyName,
            value: value
        });
        } else if (propertyName == "rotate") {
        // レイヤー回転
        this.$emit("doCommand", "rotateLayer", {
            layer: this.layer,
            rotate: value,
            isFinish: isFinish
        });
        } else if (propertyName == "x" || propertyName == "y") {
        // レイヤー移動
        var newX = propertyName == "x" ? value : this.layer.x;
        var newY = propertyName == "y" ? value : this.layer.y;
        this.$emit("doCommand", "moveLayer", {
            layer: this.layer,
            x: newX,
            y: newY,
            isFinish: isFinish
        });
        } else if (propertyName == "width" || propertyName == "height") {
        // レイヤーリサイズ
        var newWidth = propertyName == "width" ? value : this.layer.width;
        var newHeight = propertyName == "height" ? value : this.layer.height;
        this.$emit("doCommand", "resizeLayer", {
            layer: this.layer,
            width: newWidth,
            height: newHeight,
            isFinish: isFinish
        });
        }
    }

    private dupilicateLayerToSurface(isReverse : boolean)
    {
        // 面へレイヤー複製
        this.$emit("doCommand", "dupilicateLayerToSurface", { layer : this.layer, isReverse : isReverse });
    }

    public deleteLayer(): void {
        // レイヤー削除
        this.$emit("doCommand", "deleteLayer", { deleteLayer: this.layer });
    }

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus() 
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }
    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private get x() {
        return this.layer.x;
    }

    private get y() {
        return this.layer.y;
    }

    private get width() {
        return this.layer.width;
    }

    private get height() {
        return this.layer.height;
    }

    private get rotate() {
        return this.layer.rotate.toFixed(2);
    }

    // レイヤーの整列
    private align(direction: 'horizontal' | 'vertical', alignment: string)
    {
        if (direction === 'horizontal')
        {
            this.$emit("doCommand", "alignLayerHorizontal", { layer: this.layer, alignment });
        }
        else
        {
            this.$emit("doCommand", "alignLayerVertical", { layer: this.layer, alignment });
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    private onChangingValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, false);
    }

    private onChangedValue(value: number, tag: string) {
        this.changeLayerProperty(value, tag, true);
    }

    public get currentDocument(): Document {
        return this.$store.getters.document;
    }
}
